import axiosInstance from "../../../../config/apiConfig"; // your axios instance
import { useQuery } from '@tanstack/react-query';

const fetchRemovedBlogs = async () => {
  try {
    const { data } = await axiosInstance.get('reports/removed-blogs');
    return data; 
  } catch (error) {
    console.error('Error fetching removed blogs:', error.response?.data || error.message);
    return [];
  }
};

 const useRemovedPosts = () => {
  return useQuery({
    queryKey: ['removedPosts'],
    queryFn: fetchRemovedBlogs,
    staleTime: 1000 * 60 * 5, 
  });
};

export default useRemovedPosts
